<template>
  <div class="all">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="航班延误取消证明打印" name="first">
        <el-form :model="form" label-width="200px">
          <el-form-item label="航班号" class="lab">
            <el-col :span="11">
              <el-input
                v-model="form.name"
                style="width:300px"
                placeholder="请填写航班号"
              ></el-input>
            </el-col>
            <!-- <div v-if="form.name.length==0" class="mes">
          *请输入航班号
        </div> -->
          </el-form-item>
          <el-form-item label="出行日期选择">
            <el-col :span="11">
              <date-picker></date-picker>
            </el-col>
            <el-col :span="1">&nbsp;&nbsp;&nbsp; </el-col>
            <el-col :span="11">
              <!-- <div v-if="form.region.toString().length==0" class="mes">
          *请选择出行日期
        </div> -->
            </el-col>
          </el-form-item>

          <el-form-item label-width="500px">
            <el-button class="submit" @click="search">打印</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { defineComponent, ref, getCurrentInstance } from 'vue';
import { FlightService } from '@/utils/api/flight';
import DatePicker from '@/components/MainArea/components/DatePicker.vue';
export default defineComponent({
  name: 'all',
  components:{DatePicker},
  setup() {
    const form = ref({
        name: '',
        region: '',
    });
    const activeName=ref('first');
    const ID = ref({ flightID: '' });
    const { ctx } = getCurrentInstance();
    const dialogVisible = ref(false);
    const search = () => {
          ID.value.flightID = form.value.name;
          FlightService.findFlightExit(ID.value)
            .then((res) => {
              console.log(res);
              if(form.value.name.length === 0)
                 ctx.$message({
                  type: 'warning',
                  message: '请填写航班号',})
              else if(form.value.name === 'F123')
                 ctx.$message({
                  type: 'warning',
                  message: '航班未延迟',})
              else if(res.data === true)
                ctx.$message({
                  type: 'success',
                  message: '打印成功',})
              else 
                ctx.$message({
                  type: 'warning',
                  message: '航班不存在',})
            })
            .catch((error) => {
              console.log(error);
            });        
      //向后端数据传输接口
    };
    const open1=()=> {
      (dialogVisible.value = false),
        ctx.$alert('很抱歉没有相应的遗失物', 'Sorry', {
          confirmButtonText: '确定',
        });
    };
    const open2=()=> {
      (dialogVisible.value = false),
        ctx.$alert('请联系客服进行物品认领', 'Message', {
          confirmButtonText: '确定',
        });
    };
    return {
      activeName,
      search,
      open1,
      open2,
      dialogVisible,
      form,
      imgUrl: require('@/assets/img/Luggage.jpg'),
      phone: require('@/assets/img/phone.jpg'),
    };
  },
 
});
</script>





<style lang="scss" scoped>
@import '@/assets/css/config.scss';
.all {
  padding-top: 30px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;

  .el-tab-pane {
    border-radius: 5px solid;
  }
  .el-tabs.el-tabs--top {
    :deep(.el-tabs__item) {
      // border: 1px solid grey;
      border: none;
      color: #466da1;
      background-color: rgb(70, 109, 161);
      // height: 100px;
      width: 200px;
      padding: 0 20px;
      // margin: 20px;
      &.is-active {
        color: white;
        font-size: 15px;
      }
    }
    :deep(.el-tabs__header.is-top) {
      margin-right: 0;
      color: black;
      // margin-bottom: 25px;
      margin-bottom: -1px;
    }
    :deep(.el-tabs__nav.is-top) {
      background-color: rgb(70, 109, 161);
      height: 60px;
      //width: 400px;
      line-height: 60px;
      padding-left: 0px;
    }
    .el-form {
      padding-top: 50px;
    }
    .el-tab-pane {
      max-height: 400px;
      overflow: hidden;
    }
  }
  .mes {
    color: red;
    font-size: 5px;
  }
  .el-button--primary {
    color: #fff;
    background-color: #466da1;
    border-color: #466da1;
  }
}
.submit {
  height: 20px;
  width: 100px;
  margin-left: 50px;
  background-color: $themeRed;
  color: white;
  font-weight: 600;
}
</style>
